module.exports = __webpack_public_path__ + "static/img/news-22.4dfc6c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/news-22.jpg
// module id = M0c6
// module chunks = 5